import { render } from "./Footer.vue?vue&type=template&id=96df7692&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=96df7692&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96df7692"]])

export default __exports__